import React from 'react';
import Counter from '../../components/Counter';
import ButtonTwo from '../../components/Button/ButtonTwo';

import aboutImg from '../../assets/img/about/ed1.jpg';
import aboutImg2 from '../../assets/img/about/about-5-2.jpg';
import shapeImg from '../../assets/img/about/shape-5-1.png';
import edMadam from '../../assets/img/about/edMadam.jpg';
import edMadamNew from '../../assets/img/about/edMadamNew.jpg';
import edMadamNew2 from '../../assets/img/about/edMadamNew2.jpg';

const About = () => {
  return (
    <div id="it-about" className="it-about-5-area fix pt-120 pb-150">
      <div className="container container-1520 ">
        <div className="row align-items-center">
          <div className="col-xl-5 col-lg-5 order-1 order-lg-0">
            <div className="it-about-5-thumb">
              <img src={edMadamNew2} alt="" />
            </div>
          </div>
          <div className="col-xl-7 col-lg-7 order-0 order-lg-1">
            <div className="it-about-5-right p-relative">
              <div className="it-about-5-shape-1 d-none d-lg-block">
                <img src={shapeImg} alt="" />
              </div>
              <div className="it-about-2-title-box mb-30">
                <span className="it-section-subtitle red-border">A message from the ED</span>
                <h3 className="it-section-title d-block">
                  Dr. Musfireh Siddiqeh
                </h3>
                <h5 className="it-section-title d-block">
                Executive Director
                </h5>
              </div>

              <div className="row align-items-center align-items-xl-end">
                <div className="col-xl-12 col-lg-12 col-md-12">
                  <div className="it-about-5-content">
                    <p className="mb-30">
                    Welcome to the Rawalpindi Institute of Cardiology (RIC) – a center of excellence dedicated to providing high-quality cardiac care with compassion, innovation, and integrity. At RIC, we are committed to delivering state-of-the-art cardiovascular treatment, advanced diagnostics, and lifesaving interventions. Our highly skilled team of cardiologists, surgeons, nurses, and allied healthcare professionals works tirelessly to ensure that every patient receives the best possible care.

                    As a premier cardiac institute, we focus on ensuring that every patient is treated with dignity, respect, and the highest medical standards, utilizing modern techniques and equipment to enhance treatment outcomes, training future healthcare professionals and contributing to advancements in cardiac medicine, raising awareness about heart diseases and promoting preventive cardiology. Our vision is to make RIC a leader in cardiovascular care, not just in Punjab but across Pakistan. We strive for continuous improvement, and your feedback is always welcome as we work to enhance our services. Thank you for trusting us with your heart health.

                    We remain dedicated to serving you with compassion, commitment, and excellence.
                    </p>
                    {/* <div className="it-about-5-client-wrap d-flex align-items-center">
                      <div className="it-about-5-client-item style-1">
                        <span className="about-funfact-title">
                          01. Clients consulted
                        </span>
                        <i className="about-funfact-number">
                          <Counter
                            start={0}
                            end={532}
                            duration={2}
                            counterSubText={'+'}
                          />
                        </i>
                      </div>
                      <div className="it-about-5-client-item style-2">
                        <span className="about-funfact-title">
                          02. Success clients
                        </span>
                        <i className="about-funfact-number">
                          <Counter
                            start={0}
                            end={95}
                            duration={5}
                            counterSubText={'%'}
                          />
                        </i>
                      </div>
                    </div> */}
                    <div className="it-slider-button mt-35">
                      <ButtonTwo
                        btnURL="/about-us"
                        btnClass="it-btn-theme red-bg mr-35"
                        btnText="Discover More"
                      />
                    </div>
                  </div>
                </div>
                {/* <div className="col-xl-5 col-lg-5 col-md-5">
                  <div className="it-about-5-thumb-sm text-end">
                    <img src={aboutImg2} alt="" />
                  </div>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
